import React from "react"

import {PromotionStatus, PromotionType} from "@irati/types"
import {QueryPromotionStatusArgs} from "@irati/types/ops"
import Query, {QueryComponentProps} from "@irati/utils/services/apollo/Query"

import promotionStatusQuery from "../../services/queries/promotionStatus"

interface Props extends Omit<QueryComponentProps<{promotionStatus: PromotionStatus}, QueryPromotionStatusArgs>, "query"> {
  type: PromotionType
}

const PromotionQueryComponent: React.FC<Props> = ({type, ...props}) => <Query {...props} query={promotionStatusQuery} variables={{type}} />

export default PromotionQueryComponent
